import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const InvisibleReCAPTCHA = React.forwardRef<ReCAPTCHA, unknown>(
  (_props, ref) => {
    if (window.BYPASS_CAPTCHA) return null;

    return (
      <ReCAPTCHA
        style={{ display: "none" }}
        sitekey={window.RECAPTCHA_SITE_KEY}
        size="invisible"
        ref={ref}
      />
    );
  }
);

export default InvisibleReCAPTCHA;
